import { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface ScrollIndicatorProps {
  wordCount: number;
  minWords?: number;
}

export function ScrollIndicator({ wordCount, minWords = 800 }: ScrollIndicatorProps) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY < 150);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Don't show for short articles
  if (wordCount < minWords) return null;

  const scrollToContent = () => {
    const firstHeading = document.querySelector("article h2, article h3");
    if (firstHeading) {
      firstHeading.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      window.scrollTo({ top: 400, behavior: "smooth" });
    }
  };

  return (
    <div
      className={cn(
        "fixed bottom-8 left-1/2 -translate-x-1/2 z-40 transition-all duration-300",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      )}
    >
      <button
        onClick={scrollToContent}
        className="flex flex-col items-center gap-1 px-4 py-2 rounded-full bg-card/90 backdrop-blur-sm border border-border shadow-lg hover:bg-card transition-colors group"
        aria-label="Scroll ned til indholdet"
      >
        <span className="text-xs font-medium text-muted-foreground">Scroll ned</span>
        <ChevronDown className="w-4 h-4 text-primary animate-bounce-slow" />
      </button>
    </div>
  );
}

export default ScrollIndicator;
